<script>
    import DocumentItem from '../../components/document-item/document-item.svelte'
    import InputFile from '../../components/input-file/input-file.svelte'
    import AddInput from '../../components/add-input/add-input.svelte'
    import Button from '../../components/button/button.svelte'
    import RoundInfoIco from '../../components/icons/round-info.svelte'
    import InputDrag from '../../components/input-drag/input.drag.svelte'
    import uploadFilesStore from '../../store/upload/upload-separately'
    import {documentTypes} from "../../store/upload/document-types"
    import RoundCheckIco from '../../components/icons/round-check.svelte'

    let isReading = false

    let uploadIdCardFront = true
    let uploadIdCardBack = true
    let uploadDrivingLicense = false
    let uploadPassport = false

    let files = {}
    uploadFilesStore.subscribe(value => {
        files = value
    })

    const onInputChange = (type) => (event) => {
        uploadFilesStore.checkFile(event.detail.file, type)
    }

    function areDocumentsReadyForReading(documents) {
        const idFront2021 = documents[documentTypes.id_2021_front]
        const idFront2012 = documents[documentTypes.id_2012_front]
        const idBack2012 = documents[documentTypes.id_2012_back]
        const idFront2005 = documents[documentTypes.id_2005_front]
        const idBack2005 = documents[documentTypes.id_2005_back]
        const idFrontSK = documents[documentTypes.id_svk_front]
        const idBackSK = documents[documentTypes.id_svk_back]
        return documents && (
           (idFront2021 && idFront2021.isValid && idBack2012 && idBack2012.isValid) ||
           (idFront2012 && idFront2012.isValid && idBack2012 && idBack2012.isValid) ||
           (idFront2005 && idFront2005.isValid && idBack2005 && idBack2005.isValid) ||
           (idFrontSK && idFrontSK.isValid && idBackSK && idBackSK.isValid)
        )
    }

    function deleteDocument(event) {
        uploadFilesStore.remove(event.detail.id)
    }

    function getResultsSync() {
        if (areDocumentsReadyForReading(files)) {
            uploadFilesStore.getResultSynchronous()
        }
    }

</script>

<style lang="scss">
    .upload-separately {
        h2 {
            font-family: Roboto;
            font-weight: 700;
            font-size: 14px;
            color: #C8C4C4;
            letter-spacing: 1px;
            margin-bottom: 15px;
        }
        .input-wrapper {
            margin-bottom: 15px;
        }
        .actions {
            display:flex;
            margin-top: 30px;
            @media screen and (max-width: 600px) {
                flex-direction: column;
            }
            > div {
                flex: 1 1 50%;
                &.left {
                    padding-left: 30px;
                    .message {
                        font-family: Roboto;
                        font-weight: 300;
                        font-size: 15px;
                        color: #FFFFFF;
                        letter-spacing: 0.2px;
                        line-height: 29px;
                        position: relative;
                        .ico {
                            position: absolute;
                            top: 2px;
                            left: -30px;
                        }
                    }
                    .message-info {
                        font-family: Roboto;
                        font-weight: 300;
                        font-size: 13px;
                        color: #808683;
                        letter-spacing: 0.17px;
                        line-height: 18px;
                        @media screen and (max-width: 600px) {
                            margin-bottom: 20px;
                        }

                    }
                }
                &.right {
                    text-align: right;
                }
            }
        }
    }
</style>

<div class="upload-separately">
    <h2>ID CARD</h2>

    <div class="input-wrapper">
        {#if !uploadIdCardFront}
            <AddInput text="Add Id Card Front" />
        {:else if files[documentTypes.id_2012_front]}
            <DocumentItem document={files[documentTypes.id_2012_front]} on:delete={deleteDocument}/>
        {:else if files[documentTypes.id_2005_front]}
            <DocumentItem document={files[documentTypes.id_2005_front]} on:delete={deleteDocument}/>
        {:else}
            <InputFile on:change={onInputChange(documentTypes.id_svk_front)} text="Select Id Card Front Side..." />
        {/if}
    </div>

    <div class="input-wrapper">
        {#if !uploadIdCardBack}
            <AddInput text="Add Id Card Back" />
        {:else if files[documentTypes.id_2012_back]}
            <DocumentItem document={files[documentTypes.id_2012_back]} on:delete={deleteDocument}/>
        {:else if files[documentTypes.id_2005_back]}
            <DocumentItem document={files[documentTypes.id_2005_back]} on:delete={deleteDocument}/>
        {:else}
            <InputFile on:change={onInputChange(documentTypes.id_svk_back)} text="Select Id Card Back Side..." />
        {/if}
    </div>

    {#if false}
        {#if !uploadDrivingLicense}
            <AddInput text="Add Driving Licence" on:click={() => uploadDrivingLicense = true} />
        {:else if files[documentTypes.driving_license]}
            <DocumentItem />
        {:else}
            <InputFile on:change={onInputChange(documentTypes.driving_license)} text="Select Driving License..." />
        {/if}

        {#if !uploadPassport}
            <AddInput text="Add Passport" on:click={() => uploadPassport = true}/>
        {:else if files[documentTypes.passport_2006]}
            <DocumentItem />
        {:else}
            <InputFile on:change={onInputChange(documentTypes.passport_2006)} text="Select Passport..." />
        {/if}
    {/if}


    <div class="actions">
        <div class="left">
            <div class="message">
                Uploaded documents <b>{Object.entries(files).length}/2</b>
                <div class="ico">
                    {#if areDocumentsReadyForReading(files)}
                        <RoundCheckIco />
                    {:else}
                        <RoundInfoIco />
                    {/if}
                </div>
            </div>
            <div class="message-info">
                To proceed this operations you must upload every needed documents
            </div>
        </div>
        <div class="right">
            <Button on:click={getResultsSync} disabled={!areDocumentsReadyForReading(files)} text="READ documents" />
        </div>
    </div>

</div>
